/* eslint-disable max-len */
import { SvgProps } from './types'

export const NotebookHouseIcon = ({ color, className }: SvgProps) => {
  let drawColor = color
  if (drawColor === 'blue') {
    drawColor = '#00BFFF'
  } else if (drawColor === 'pink') {
    drawColor = '#CC00A1'
  }

  return (
    <svg 
      width="58" 
      height="56" 
      viewBox="0 0 58 56" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M5.00391 38.0737V11.0472C5.00391 10.4625 5.47825 9.98816 6.0629 9.98816H51.9859C52.5705 9.98816 53.0449 10.4625 53.0449 11.0472V38.0737" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M1.75552 40.1365V38.5204H23.9448V40.8314H34.0991V38.5204H56.2884V40.1365C56.2884 42.9218 54.027 45.1832 51.2416 45.1832H6.79678C4.0114 45.1832 1.75 42.9218 1.75 40.1365H1.75552Z" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M40.7124 23.1263L29.0193 13.667L17.3262 23.1263" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M21.1377 23.3358V34.3836H26.2562V27.6159H31.7883V34.3836H36.9068V23.3358" stroke={drawColor} strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}
